import { Input } from "@bcc/components/ui/input";
import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setOrdersFilterBarSearchClearTestId, setOrdersFilterBarSearchInputTestId } from "./orders-filter-bar.utils";

interface OrdersSearchInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onClear: () => void;
}

export function OrdersSearchInput({ value, onChange, onClear }: OrdersSearchInputProps) {
  const { t } = useTranslation();

  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        data-testid={setOrdersFilterBarSearchInputTestId()}
        placeholder={t("views.orders.searchPlaceholder")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-9"
      />
      {value && (
        <button
          type="button"
          data-testid={setOrdersFilterBarSearchClearTestId()}
          onClick={onClear}
          aria-label={t("views.orders.clearSearch")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
